<template>
    <v-container fluid class="py-16">
        <v-layout row wrap>
            <v-flex xs12 sm6 offset-sm3 class="text-center" mt-5>
                <Alert v-if="errors.visible" :error="errors.message" />

                <h1>Pievienot jaunu piedāvājumu</h1>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 mt-3>
                <form @submit.prevent="addOffer">
                    <v-layout column>
                        <v-flex>
                            <v-text-field
                                name="title"
                                v-model="form.title"
                                id="title"
                                label="Nosaukums"
                                type="text"
                                :error-messages="titleErrors"
                                :counter="256"
                                required
                                @input="$v.form.title.$touch()"
                                @blur="$v.form.title.$touch()"
                            ></v-text-field>
                        </v-flex>

                        <v-flex>
                            <v-textarea
                                solo
                                name="description"
                                v-model="form.description"
                                id="description"
                                label="Apraksts"
                                :error-messages="descriptionErrors"
                                @input="$v.form.description.$touch()"
                                @blur="$v.form.description.$touch()"
                            ></v-textarea>
                        </v-flex>

                        <v-flex>
                            <v-checkbox
                                name="isActive"
                                v-model="form.isActive"
                                id="isActive"
                                color="primary"
                                :error-messages="isActiveErrors"
                                @input="$v.form.isActive.$touch()"
                                @blur="$v.form.isActive.$touch()"
                            >
                                <template v-slot:label>Piedāvājums ir aktīvs?</template>
                            </v-checkbox>
                        </v-flex>

                        <v-divider></v-divider>

                        <v-layout
                            v-for="(image, i) in $v.form.images.$each.$iter"
                            :key="i"
                        >
                            <v-col cols="6">
                                <v-file-input
                                    v-model="image.data.$model"
                                    accept="image/png, image/jpeg, image/jpg, image/bmp"
                                    placeholder="Izvēlies bildi..."
                                    prepend-icon="mdi-camera"
                                    label="Bilde"
                                    @change="createImage(i)"
                                    @click:clear="deleteImage(i)"
                                    :error-messages="validateImage(image.data, i)"
                                    clearable
                                ></v-file-input>
                            </v-col>

                            <v-col cols="6">
                                <v-img
                                    max-height="300"
                                    :src="form.images[i].preview"
                                ></v-img>
                            </v-col>
                        </v-layout>

                        <v-flex my-5>
                            <v-btn
                                dark
                                small
                                color="success"
                                v-on:click="addImage"
                            >
                                <v-icon dark>
                                    {{ newImage.icon }}
                                </v-icon>
                                {{ newImage.title }}
                            </v-btn>
                        </v-flex>

                        <v-divider></v-divider>

                        <v-flex mt-5>
                            <v-btn
                                color="primary"
                                type="submit"
                                :loading="loading"
                                :disabled="loading"
                                small
                            >
                                Pievienot
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex';
    import { validationMixin } from 'vuelidate';
    import { required, maxLength, minLength } from 'vuelidate/lib/validators';
    import Alert from '../components/popups/Alert';
    export default {
        mixins: [ validationMixin ],

        validations: {
            form: {
                title: { required, minLength: minLength(3), maxLength: maxLength(256) },
                description: { maxLength: maxLength(4096) },
                isActive: { },
                images: {
                    $each: {
                        data: {
                            isFileSize(value) {
                                if (!value || value === '' || value === undefined) return true;
                                return (value.size < 5000000);
                            }
                        }
                    }
                },
            },
        },

        components: {
            Alert,
        },

        data: () => ({
            form: {
                title: '',
                description: '',
                isActive: true,
                images: [],
                recaptcha: '',
            },
            errors: {
                title: null,
                description: null,
                isActive: null,
                images: null,
                message: null,
                visible: false,
            },
            loading: false,
            newImage: { title: 'Jauna bilde', icon: 'mdi-plus' },
        }),

        computed: {
            titleErrors () {
                const errors = [];
                if (this.errors.title) {
                    errors.push(this.errors.title[0]);
                    this.errors.title = null;
                }
                if (!this.$v.form.title.$dirty) return errors;
                !this.$v.form.title.maxLength && errors.push('Nedrīkst pārsniegt 256 rakstzīmes');
                !this.$v.form.title.minLength && errors.push('Jābūt vismaz 3 rakstzīmēm');
                !this.$v.form.title.required && errors.push('Obligāts lauks');

                return errors
            },
            descriptionErrors () {
                const errors = [];
                if (this.errors.description) {
                    errors.push(this.errors.description[0]);
                    this.errors.description = null;
                }
                if (!this.$v.form.description.$dirty) return errors;
                !this.$v.form.description.maxLength && errors.push('Nedrīkst pārsniegt 4096 rakstzīmes');
                return errors;
            },
            isActiveErrors () {
                const errors = [];
                if (this.errors.isActive) {
                    errors.push(this.errors.isActive[0]);
                    this.errors.isActive = null;
                }
                if (!this.$v.form.isActive.$dirty) return errors;
                return errors;
            },
        },

        methods: {
            ...mapActions({
                getOfferListAction: 'offers/getOffers',
                setMessageAction: 'message/setMessage',
            }),
            addOffer() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.errors.message = 'Dati satur kļūdas.';
                    this.errors.visible = true;
                    this.resetMessageTimeout(10000);
                    this.setMessageAction( { message: 'Kļūda!', isVisible: true, type: 'error' } );
                } else {
                    this.loading = true;
                    this.removeEmptyImages();
                    this.$recaptcha('addOffer').then(token => {
                        this.form.recaptcha = token;
                        axios.post('/api/storeOffer', this.form).then(response => {
                            this.loading  = false;
                            this.form.recaptcha = '';
                            if (response.data.success) {
                                this.setMessageAction( { message: response.data.message, isVisible: true, type: 'success' } );
                                this.getOfferListAction();
                                this.$router.push({ name: 'Home' });
                            } else {
                                this.errors.message = response.data.message;
                                this.errors.visible = true;
                                this.setMessageAction( { message: this.errors.message, isVisible: true, type: 'error' } );

                                if (response.data.errors) {
                                    if (response.data.errors.title) {
                                        this.errors.title = response.data.errors.title;
                                    }
                                    if (response.data.errors.description) {
                                        this.errors.description = response.data.errors.description;
                                    }
                                    if (response.data.errors.isActive) {
                                        this.errors.isActive = response.data.errors.isActive;
                                    }
                                    if (response.data.errors.images && response.data.errors.images.length > 0) {
                                        this.errors.images = response.data.errors.images;
                                    }
                                }
                            }
                            this.resetMessageTimeout(10000);
                        }).catch((error) => {
                            this.loading = true;
                            this.form.recaptcha = '';
                            this.setMessageAction( {
                                message: 'Kļūda. Lūdzu, pēc brīža mēģiniet vēlreiz!',
                                isVisible: true,
                                type: 'error'
                            } );
                        });
                    });
                }
            },
            resetMessageTimeout(time) {
                setTimeout(() => {
                    this.errors.visible = false;
                }, time)
            },
            addImage() {
                this.form.images.push( { data: null, base64: '', preview: '' } );
            },
            createImage(index) {
                if (this.form.images.length === 0
                    || !this.form.images[index]
                    || !this.form.images[index].data
                ) {
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.form.images[index].base64 = e.target.result;
                };
                reader.readAsDataURL(this.form.images[index].data);
                this.form.images[index].preview = URL.createObjectURL(this.form.images[index].data);
            },
            deleteImage(index) {
                if (this.form.images.length === 0 || !this.form.images[index]) {
                    return;
                }
                this.form.images.splice(index, 1);
            },
            validateImage(item, index) {
                const errors = [];
                if (this.errors.images
                    && this.errors.images.length > 0
                    && this.errors.images[index]
                ) {
                    errors.push(this.errors.images[index][0]);
                    this.errors.images[index] = null;
                }
                if (!item.$dirty) return errors;
                !item.isFileSize && errors.push('Bildes izmēram jābūt mazākam par 5 MB');
                return errors;
            },
            removeEmptyImages() {
                this.form.images = this.form.images.filter(image => {
                    return image.base64 && image.base64 !== '' && image.base64 !== undefined
                });
            },
        },
    }
</script>

<style scoped>

</style>
